<template>
  <div>
    <md-dialog :md-active="showDialog" id="dlg-template-product" md-height="100%" @md-opened="clearInput">
      <md-dialog-title>
        <div class="md-layout">
          <div class="md-layout-item">Template File</div>
          <div class="md-layout-item dialog-name" style="text-align:right">Template File</div>
        </div>
      </md-dialog-title>

      <md-dialog-content>
        <div style="margin:70px;">
          <div class="md-layout">
            <div class="md-layout-item md-size-30">
              <md-button class="md-dense md-raised md-primary btn-import" @click="importFile();">
                <md-icon>search</md-icon>IMPORT
              </md-button>
            </div>
            <div class="md-layout-item btn-detail">Browse File for up load data to system</div>
            <input
              type="file"
              ref="fileInput"
              class="browse-file"
              :accept="accept"
              @change="browseFile"
            >
          </div>
          <div class="md-layout" style="margin-top:70px;">
            <div class="md-layout-item md-size-30">
              <a
                ref="download"
                href="./static/files/Template_Import_Customer_Code.xls"
                download
                style="display:none"
              >Download</a>
              <md-button class="md-dense md-raised md-primary btn-export" @click="downloadFile()">
                <md-icon style="color:white !important;">file_upload</md-icon>EXPORT
              </md-button>
            </div>
            <div class="md-layout-item btn-detail">Download Template File for up load</div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="btn-close md-primary" @click="cancel">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
      <!-- @cancel="cancelImportExcel($event)" -->


  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "import-product-excel",
  props: ["showDialog","products"], 
  data() {
    return {
      accept: ".xlsx, .xls, .csv",
      showDlgExcel: false,
        dataProductsFromExcel: []
    };
  },
  created() {
    // console.log(products);
  },
  methods: {
    clearInput(){
        // console.log(this.products)
    //   this.$refs.fileInput.value = "";
    },
    cancel() {
      this.$emit("onCancel", false);
    },
    downloadFile() {
      this.$refs.download.click();
    },
    importFile() {
      this.$refs.fileInput.click();
    },
    fixdata(data) {
      var o = "",
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    browseFile(e) {
      var vm = this;
      if (window.FileReader) {
        var files = e.target.files,
          i,
          f;
        for (i = 0, f = files[i]; i != files.length; ++i) {
          var reader = new FileReader(),
            name = f.name;
          var ext = name.split(".");
          if (ext[1] == "csv") {
            reader.readAsText(e.target.files[i]);
            reader.onload = function(e) {
              var results = null;
              var csv = e.target.result;
              var lines = csv.split("\r\n");
              results = lines.slice(0, -1);
              results = results.map(data => {
                return [data];
              });
                vm.$emit('onImportExcelFile', results);
            };
          } else if (ext[1] == "xlsx" || ext[1] == "xls") {
            reader.readAsArrayBuffer(f);
            reader.onload = function(e) {
              var results,
                data = e.target.result,
                fixedData = vm.fixdata(data),
                workbook = XLSX.read(btoa(fixedData), { type: "base64" }),
                firstSheetName = workbook.SheetNames[0],
                worksheet = workbook.Sheets[firstSheetName];
                results = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                console.log(results);
            //   vm.showImportFromExcel(results);
                vm.$emit('onImportExcelFile', results);
            };
          }
        }
      } else {
        alert("FileReader are not supported in this browser.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#dlg-template-product {
  width: 700px;
  .btn-import {
    height: 60px;
    width: 134px;
    font-size:16px;
  }

  .btn-export {
    height: 60px;
    width: 134px;
    font-size:16px;
    background-color: #a8a8a8 !important;
  }

  .btn-detail {
    font-size: 18px;
    font-weight: bold;
    // vertical-align: middle;
    padding-top: 24px;
    padding-left: 20px;
  }
  .btn-close {
    color: black;
    margin-right: 20px;
  }

  .dialog-name {
    color: #9a9a9a;
  }

  .browse-file {
    display: none;
  }
}
</style>

